import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { firstDayofYear, lastDayofYear, recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';

const [LIST_PROJECTS, LIST_PROJECTS_SUCCESS, LIST_PROJECTS_FAILURE] =
  createRequestActionTypes('project/LIST_PROJECTS');

export const listProjects = createAction(
  LIST_PROJECTS,
  (searchData) => searchData,
);
const listProjectsSaga = createRequestSaga(
  LIST_PROJECTS,
  projectApi.getProjects,
);

const UNLOAD_PROJECTS = 'project/UNLOAD_PROJECTS';
export const unloadProjects = createAction(UNLOAD_PROJECTS);

const SET_PROJECT_FILTERS = 'project/SET_PROJECT_FILTERS';
export const setProjectFilters = createAction(
  SET_PROJECT_FILTERS,
  (filters) => filters,
);

const RESET_PROJECT_FILTERS = 'project/RESET_PROJECT_FILTERS';
export const resetProjectFilters = createAction(RESET_PROJECT_FILTERS);

export function* projectsSaga() {
  yield takeLatest(LIST_PROJECTS, listProjectsSaga);
}

const initialState = {
  totals: null,
  projects: null,
  error: null,
  defaultFilters: {
    searchGrade: '',
    searchPrjImpt: '',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchDpt: '',
    searchUsr: '',
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
  },
};

const projects = handleActions(
  {
    [LIST_PROJECTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data?.totals,
      projects: data.list.map((project) => ({
        id: project.prjUuid,
        prjUuid: project.prjUuid,
        prjSeq: project.prjSeq,
        prjNo: project.prjNo,
        prjTyp: project.prjTyp,
        expDay: project.expDay,
        cstStatus: project.cstStatus,
        bookingDay: project.bookingDay,
        cstGrade: project.cstGrade,
        cmpGrade: project.cmpGrade, //1/2/3/4
        cmpStatus: project.cmpStatus, //착수보고/분석설계/구축(이행)/완료(검수)
        cstNm: project.cstNm, //프로젝트명
        totalPurchase: project?.totalPurchase,
        totalSales: project?.totalSales,
        totalProfit: project?.totalProfit,
        vendorCmpNm: project.vendorCmpNm,
        useYn: project.useYn,
        ordYn: project.ordYn,
        crtDptNm: project.crtDptNm,
        crtNm: project.crtNm,
        crtGradeNm: project.crtGradeNm,
        crtDt: project.crtDt,
        cngNm: project.cngNm,
        cngDt: project.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PROJECTS]: () => initialState,
    [RESET_PROJECT_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_PROJECT_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default projects;
